import Dropzone from 'dropzone/dist/dropzone'

Dropzone.autoDiscover = false;

// $('.dropzone').each(function(){
//     var id = $(this).attr('id');

//     var container = document.getElementById(id)
//     var dropzone = new Dropzone(container, {
//         addRemoveLinks: true,
//         maxFiles: 1,
//         headers: {
//             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//         },

//         init: function() {
//             this.on("success", function(element, response) {
//                 this.element.classList.remove('__error');
//                 this.element.classList.add('__success');
//                 this.element.querySelector('.dz-button').innerHTML = 'Selected';
//             })
//             this.on("error", function(element, response) {
//                 this.element.classList.remove('__success');
//                 this.element.classList.add('__error');
//                 this.element.querySelector('.dz-button').innerHTML = 'Drop files here to upload';
//             })
//             this.on("removedfile", function(element, response) {
//                 this.element.classList.remove('__success');
//                 this.element.classList.remove('__error');
//                 this.element.querySelector('.dz-button').innerHTML = 'Drop files here to upload';
//             })
//             this.on("cancel", function(element, response) {
//                 this.element.classList.remove('__success');
//                 this.element.classList.remove('__error');
//                 this.element.querySelector('.dz-button').innerHTML = 'Drop files here to upload';
//             })
//             this.on("reset", function(element, response) {
//                 this.element.classList.remove('__success');
//                 this.element.classList.remove('__error');
//                 this.element.querySelector('.dz-button').innerHTML = 'Drop files here to upload';
//             })
//         }
//     });
// })
